/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateBotOptions,
  CreateBotStatus201,
  CreateBotStatus400,
  CreateBotStatus500,
} from '../types/CreateBot'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createBot } from '../clients/createBot'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createBotMutationKey = () => [{ url: '/v1/bots' }] as const

export function createBotMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createBotMutationKey()
  return mutationOptions<
    CreateBotStatus201,
    ResponseErrorConfig<CreateBotStatus400 | CreateBotStatus500>,
    CreateBotOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createBot({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Create a new bot
 * {@link /v1/bots}
 */
export function useCreateBot<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateBotStatus201,
      ResponseErrorConfig<CreateBotStatus400 | CreateBotStatus500>,
      CreateBotOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createBotMutationKey()

  const baseOptions = createBotMutationOptions(config) as UseMutationOptions<
    CreateBotStatus201,
    ResponseErrorConfig<CreateBotStatus400 | CreateBotStatus500>,
    CreateBotOptions,
    TContext
  >

  return useMutation<
    CreateBotStatus201,
    ResponseErrorConfig<CreateBotStatus400 | CreateBotStatus500>,
    CreateBotOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateBotStatus201,
    ResponseErrorConfig<CreateBotStatus400 | CreateBotStatus500>,
    CreateBotOptions,
    TContext
  >
}
